import { COMPANY } from '../../../config/companyConfig.js';
import { SCHEMA_IDS, SCHEMA_SITE_ROOT } from './organization.js';

/** WebSite node — homepage graph only. */
export function buildWebsiteSchema() {
  return {
    '@type': 'WebSite',
    '@id': SCHEMA_IDS.website,
    url: SCHEMA_SITE_ROOT,
    name: COMPANY.brandName,
    publisher: {
      '@id': SCHEMA_IDS.organization,
    },
    inLanguage: 'en-IN',
  };
}
